export const MAIN_MANAGE_FLIGHT_TEST_IDS = {
  // ─── Manage Flight Tab Container ───
  tabContainer: 'main-manage-flight-tab-container',
  heading: 'main-manage-flight-heading',
  subheading: 'main-manage-flight-subheading',
  image: 'main-manage-flight-image',

  // ─── Manage Flight Form ───
  form: 'main-manage-flight-form',
  emailOrLastNameInput: 'main-manage-flight-email-lastname-input',
  emailOrLastNameTooltip: 'main-manage-flight-email-lastname-tooltip',
  recordLocatorInput: 'main-manage-flight-record-locator-input',
  recordLocatorTooltip: 'main-manage-flight-record-locator-tooltip',
  errorMessage: 'main-manage-flight-error-message',
  captchaErrorMessage: 'main-manage-flight-captcha-error',
  continueButton: 'main-manage-flight-continue-btn',
} as const;
